import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft, MessageCircle } from "lucide-react";
import { useApp } from "../context/AppContext";

const PaymentCancel = () => {
    const [params] = useSearchParams();
    const resId = params.get("res");
    const { settings } = useApp();
    const wa = (settings.whatsapp_number || "").replace(/\D/g, "");
    const waHref = wa ? `https://wa.me/${wa}?text=${encodeURIComponent("Merhaba, ödemeyi iptal ettim ama yardım almak istiyorum.")}` : null;
    return (
        <section className="min-h-[70vh] flex items-center justify-center p-6" data-testid="payment-cancel-page">
            <div className="max-w-lg w-full bg-emerald_surface border border-border_green p-8 text-center">
                <XCircle className="w-14 h-14 mx-auto text-rose-400 mb-4" />
                <h1 className="font-serif text-3xl mb-2">Ödeme İptal Edildi</h1>
                <p className="text-bone/80 leading-relaxed mb-6">
                    Ödemeniz tamamlanmadı. Rezervasyonunuz henüz oluşturulmadı — istediğiniz zaman tekrar deneyebilirsiniz.
                </p>
                <div className="flex items-center justify-center gap-3 flex-wrap">
                    <Link to="/" className="btn-outline-gold"><ArrowLeft className="w-4 h-4" /> Anasayfa</Link>
                    {waHref && <a href={waHref} target="_blank" rel="noreferrer" className="btn-gold"><MessageCircle className="w-4 h-4" /> Yardım Al</a>}
                </div>
                {resId && <div className="text-[10px] text-muted_green mt-4">Referans: {resId}</div>}
            </div>
        </section>
    );
};

export default PaymentCancel;
